import React, { useEffect, useState } from 'react';

import { uploadFileS3 } from '../../../services/file.js';
import { getCategories } from '../../../services/categories.js';
import { getCategory } from '../../../services/categories.js';
import { saveContent, editContent } from '../../../services/contents.js';
import Loading from '../../../components/loading/loading.js';
import { getLocale } from '../../../helpers/helpers_general.js';
import { FormControlLabel, Switch, Box, Button, Stack, Alert } from '@mui/material';
import TextField from '../../../components/TextField/index.js';
import SelectCategory from '../../../components/Select/SelectCategory.js';
import { useAlert } from '../../../context/index.js';
import flagBR from '../../../assets/images/icons/flag-br.svg';
import flagES from '../../../assets/images/icons/flag-es.svg';

import './content-form.scss';

const ContentForm = ({ card, categoryId, setShowContentModal, onDelete }) => {
  const initialState = {
    title: '',
    description: '',
    locale: '',
    fileName: '',
    premium: false,
    categories: [],
    documents: [],
    loading: false,
    loadingFile: false,
    error: false,
    success: false,
    errorMessage: '',
    successMessage: '',
  };

  const [selectCategoryLabel, setSelectCategoryLabel] = useState('Categoria');
  const [categoryOption, setCategoryOption] = useState(null);
  const [states, setStates] = useState(initialState);
  const { setShowError, setShowSuccess, setTextSuccessAlert, setTextErrorAlert } = useAlert();

  useEffect(() => {
    getCategories().then(response =>
      setStates(prevState => ({ ...prevState, categories: response.data }))
    );

    if (categoryId) {
      getCategory(categoryId).then(response =>
        setSelectCategoryLabel(response.data.slug)
      );
      setCategoryOption(categoryId);
    }

    if (card !== undefined) {
      setStates(prevState => ({
        ...prevState,
        id: card.contentId,
        title: card.title || '',
        description: card.description || '',
        locale: getLocale(),
        premium: card.premium,
        error: false,
        success: false,
      }));
    }
  }, [card, categoryId]);

  const uploadFile = e => {
    e.preventDefault();
    setStates(prevState => ({ ...prevState, loadingFile: true }));
    uploadFileS3(e, states.title).then(data => {
      if (data !== undefined) {
        setStates(prevState => ({
          ...prevState,
          loadingFile: false,
          fileName: data.key,
          error: false,
          success: true,
          successMessage: 'Arquivo salvo com sucesso.',
          documents: states.documents.concat({
            file_locale: data.location,
            file_name: data.key,
          }),
        }));
      } else {
        setStates(prevState => ({
          ...prevState,
          loadingFile: false,
          success: false,
          error: true,
          errorMessage: 'Um erro ocorreu ao adicionar um novo arquivo.',
        }));
      }
    });
  };

  const handleSaveContent = () => {
    if (categoryOption === null) {
      setStates(prev => ({ ...prev, error: true, errorMessage: 'Selecione uma categoria.' }));
      return;
    }
    if (states.locale === '') {
      setStates(prev => ({ ...prev, error: true, errorMessage: 'Selecione uma localidade.' }));
      return;
    }
    if (states.title === '') {
      setStates(prev => ({ ...prev, error: true, errorMessage: 'Insira um título.' }));
      return;
    }
    if (states.description === '') {
      setStates(prev => ({ ...prev, error: true, errorMessage: 'Insira uma descrição.' }));
      return;
    }
    if (states.documents.length === 0) {
      setStates(prev => ({ ...prev, error: true, errorMessage: 'Insira ao menos 1 arquivo.' }));
      return;
    }

    setStates(prev => ({ ...prev, success: false }));
    saveContent({ ...states, category_id: categoryOption }).then(
      () => {
        setShowSuccess(true);
        setTextSuccessAlert('Conteúdo criado com sucesso!');
        setShowContentModal(prev => ({ ...prev, showNewContentModal: false }));
        setTimeout(() => window.location.reload(), 1400);
      },
      () => {
        setShowError(true);
        setTextErrorAlert('Categoria ou título não encontrado.');
        setShowContentModal(prev => ({ ...prev, showNewContentModal: false }));
      }
    );
  };

  const handleEditContent = () => {
    if (states.title === '') {
      setStates(prev => ({ ...prev, error: true, errorMessage: 'Insira um título.' }));
      return;
    }
    if (states.description === '') {
      setStates(prev => ({ ...prev, error: true, errorMessage: 'Insira uma descrição.' }));
      return;
    }

    setStates(prev => ({ ...prev, success: false }));
    editContent({ ...states, category_id: categoryOption }).then(
      () => {
        setShowSuccess(true);
        setTextSuccessAlert('Conteúdo editado com sucesso!');
        setShowContentModal(prev => ({ ...prev, showNewContentModal: false }));
        setTimeout(() => window.location.reload(), 1400);
      },
      () => {
        setShowError(true);
        setTextErrorAlert('Categoria ou título não encontrado.');
        setShowContentModal(prev => ({ ...prev, showNewContentModal: false }));
      }
    );
  };

  return (
    <>
      {states.loading ? (
        <Loading />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

          {/* Categoria — largura total */}
          <SelectCategory
            optionsItems={states.categories}
            setIdValue={setCategoryOption}
            selectCategoryLabel={selectCategoryLabel}
            setSelectCategoryLabel={setSelectCategoryLabel}
          />

          {/* Idioma + Premium na mesma linha */}
          <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: '8px' }}>
              {[{ value: 'pt-BR', flag: flagBR, label: 'PT-BR' }, { value: 'es', flag: flagES, label: 'ES' }].map(opt => {
                const selected = states.locale === opt.value;
                return (
                  <Box
                    key={opt.value}
                    onClick={() => setStates(prev => ({ ...prev, locale: opt.value }))}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: '6px',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      border: selected ? '2px solid #006494' : '2px solid #e0e0e0',
                      backgroundColor: selected ? '#e8f4fb' : '#fff',
                      cursor: 'pointer',
                      fontWeight: selected ? 600 : 400,
                      fontSize: '13px',
                      color: selected ? '#006494' : '#49454F',
                      transition: 'all 0.15s',
                      '&:hover': { borderColor: '#006494', backgroundColor: '#f0f8ff' },
                    }}
                  >
                    <img src={opt.flag} alt={opt.label} style={{ width: '20px', height: '14px', borderRadius: '2px' }} />
                    {opt.label}
                  </Box>
                );
              })}
            </Box>
            <FormControlLabel
              control={
                <Switch
                  checked={states.premium}
                  onChange={e => setStates(prev => ({ ...prev, premium: e.target.checked }))}
                />
              }
              label="Premium"
              sx={{ flexShrink: 0, margin: 0 }}
            />
          </Box>

          {/* Título — textarea */}
          <TextField
            label="Título"
            value={states.title}
            onChange={e => setStates(prev => ({ ...prev, title: e.target.value }))}
            required={true}
          />

          {/* Descrição — textarea */}
          <TextField
            label="Conteúdo"
            value={states.description}
            onChange={e => setStates(prev => ({ ...prev, description: e.target.value }))}
            required={true}
          />

          {/* Upload de arquivos */}
          <div className="multi-file-upload">
            <label className="multi-file-label">
              Arquivos
              <span>Você pode enviar múltiplos arquivos (PDF, DOCX, XLSX, etc.)</span>
            </label>
            <div className="multi-file-drop-area" onClick={() => document.getElementById('multi-file-input').click()}>
              <input
                id="multi-file-input"
                type="file"
                multiple
                style={{ display: 'none' }}
                onChange={uploadFile}
              />
              {states.loadingFile ? (
                <span className="multi-file-hint">Enviando arquivo...</span>
              ) : (
                <>
                  <span className="multi-file-icon">📁</span>
                  <span className="multi-file-hint">Clique para selecionar arquivos</span>
                  <span className="multi-file-sub">ou arraste e solte aqui</span>
                </>
              )}
            </div>
            {states.documents.length > 0 && (
              <ul className="multi-file-list">
                {states.documents.map((doc, i) => (
                  <li key={i}>{doc.file_name.split('/').pop()}</li>
                ))}
              </ul>
            )}
          </div>

          {states.error && (
            <Stack sx={{ width: '100%' }}>
              <Alert severity="error">{states.errorMessage}</Alert>
            </Stack>
          )}
          {states.success && (
            <Stack sx={{ width: '100%' }}>
              <Alert severity="success">{states.successMessage}</Alert>
            </Stack>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px' }}>
            {states.id !== undefined && onDelete ? (
              <Button
                type="button"
                variant="outlined"
                onClick={onDelete}
                sx={{
                  fontWeight: 600,
                  height: '44px',
                  borderRadius: '10px',
                  color: '#c62828',
                  borderColor: '#c62828',
                  '&:hover': { backgroundColor: '#fdecea', borderColor: '#c62828' },
                }}
              >
                Excluir
              </Button>
            ) : <Box />}
            <Button
              type="button"
              variant="contained"
              onClick={states.id === undefined ? handleSaveContent : handleEditContent}
              className="btns"
              sx={{
                fontWeight: 600,
                width: '150px',
                height: '44px',
                borderRadius: '10px',
                backgroundColor: 'primary.main',
              }}
            >
              Salvar
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ContentForm;
